import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@f2e/ui/components/base"
import { cn } from "@f2e/ui/lib/utils"

import { getAvatarName, getAvatarBackgroundColor } from "@/lib/utils"
import { User } from "@/types"
import { useResourceUrl } from "@/hooks"
export interface UserAvatarProps {
  className?: string
  user: User
}

const UserAvatar = ({ className, user }: UserAvatarProps) => {
  const avatarUrl = useResourceUrl(user.avatar)
  return (
    <HoverCard closeDelay={0}>
      <HoverCardTrigger asChild>
        <Avatar className={cn("w-6 h-6 text-sm", className)}>
          <AvatarImage
            src={avatarUrl}
            alt={user.name ?? ""}
            className="object-cover"
          />
          <AvatarFallback
            style={{ backgroundColor: getAvatarBackgroundColor(user.email) }}
          >
            {getAvatarName(user.name?.[0])}
          </AvatarFallback>
        </Avatar>
      </HoverCardTrigger>
      <HoverCardContent sideOffset={4} className="w-auto">
        <div className="flex flex-col gap-1">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Avatar className="w-8 h-8">
                <AvatarImage
                  src={user.avatar ?? ""}
                  alt={user.name ?? ""}
                  className="object-cover"
                />
                <AvatarFallback
                  style={{
                    backgroundColor: getAvatarBackgroundColor(user.email),
                  }}
                >
                  {getAvatarName(user.name?.[0])}
                </AvatarFallback>
              </Avatar>
              <div className="grid grid-rows-2 text-sm">
                <div>{user.name}</div>
                <div>{user.email}</div>
              </div>
            </div>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}

export default UserAvatar
